export const PAGINATION = {
  SERVER: "server",
  CLIENT: "client",
};

export const MAX_PAGE_SIZE = 999999999; // 1 billionish
